import React, { useMemo } from 'react';
import { FieldError, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { fr } from 'date-fns/locale';

const DatePickerInput: React.FC<{
  control: any;
  id: string;
  label: string;
  showTimeSelect?: boolean;
  showTimeSelectOnly?: boolean;
  error?: FieldError;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  errorClassName?: string;
  disabled?: boolean;
}> = ({
  control,
  id,
  label,
  showTimeSelect,
  showTimeSelectOnly,
  error,
  placeholder = 'jj/mm/aaaa',
  minDate,
  maxDate,
  className = 'relative w-full',
  inputClassName = 'block w-full ring-1 ring-neutral-300 shadow-sm py-3 px-4 border border-neutral-300 rounded-input text-neutral-900 text-body-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors',
  labelClassName = 'block text-neutral-700 text-body-sm font-medium mb-2',
  errorClassName = 'flex italic font-main text-body-sm text-danger-600 mt-1',
  disabled = false,
}) => {
  const errorComponent = useMemo(
    () => error?.message && <p className={errorClassName}>{error.message}</p>,
    [error?.message],
  );

  const dateFormat = useMemo(() => {
    if (showTimeSelectOnly) {
      return 'HH:mm';
    }

    return showTimeSelect ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';
  }, [showTimeSelect, showTimeSelectOnly]);

  return (
    <div className={className}>
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      <Controller
        control={control}
        name={id}
        render={({ field }) => {
          const value =
            typeof field.value === 'string'
              ? moment(field.value).toDate()
              : field.value;

          return (
            <DatePicker
              showTimeSelect={!!showTimeSelect}
              showTimeSelectOnly={!!showTimeSelectOnly}
              className={inputClassName}
              placeholderText={placeholder}
              onChange={(date) => {
                field.onChange(date);
              }}
              selected={value}
              locale={fr}
              dateFormat={dateFormat}
              timeFormat="HH:mm"
              timeIntervals={15}
              isClearable
              showYearDropdown
              yearDropdownItemNumber={100}
              scrollableYearDropdown
              minDate={minDate}
              maxDate={maxDate}
              disabled={!!disabled}
            />
          );
        }}
      />

      {errorComponent}
    </div>
  );
};

export default DatePickerInput;
